import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { SnackbarProvider } from 'atoms/Snackbar';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Theme from './Theme';

ReactDOM.render(
  <React.StrictMode>
    {/* eslint-disable-next-line */}
    {/* @ts-ignore */}
    <Provider store={store}>
      <Theme>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </Theme>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
